import React from 'react';
import { useStats } from 'react-instantsearch';

const Stats = () => {
    const { nbHits } = useStats();

    return (
        <div className="filters__meta">
            <div className="filters__results">
                <span className="filters__count">{nbHits.toLocaleString()}</span>Results
            </div>
        </div>
    );
};

export default Stats;
